import { render } from "./TenantCatalogo.vue?vue&type=template&id=3c54b400&scoped=true"
import script from "./TenantCatalogo.vue?vue&type=script&lang=js"
export * from "./TenantCatalogo.vue?vue&type=script&lang=js"

import "./TenantCatalogo.vue?vue&type=style&index=0&id=3c54b400&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c54b400"]])

export default __exports__